export default [
	{
		error: 'invalid_grant',
		header: 'Anmeldung fehlgeschlagen',
		message: 'Der Benutzername oder das Passwort sind ungültig.',
	},
	{
		error: 'invalid_subscription',
		header: 'Anmeldung fehlgeschlagen',
		message: 'Für Ihre Anmeldung wird ein anderes Abo benötigt.',
		code: 1000,
	},
	{
		error: 'invalid_subscription',
		header: '',
		message: 'Das angeforderte Modul ist nicht Teil ihres Abos.',
		code: 2000,
	},
	{
		error: 'invalid_subscription',
		header: '',
		message:
			'Für das angeforderte Modul wird HausPerfekt ab der Version 14.X benötigt.',
		messageShort: 'HausPerfekt ab der Version 14.X wird benötigt',
		code: 2001,
	},
	{
		error: 'invalid_subscription',
		header: '',
		message: 'Die angeforderte Funktion ist nicht teil ihres Abos.',
		code: 3000,
	},
	{
		error: 'invalid_subscription',
		header: '',
		message:
			'Durch die Änderung des Abo-Models Ihres Anbieters werden sie abgemeldet.',
		code: 3001,
	},
	{
		error: 'no database',
		header: 'Keine Berechtigung',
		message:
			'Ihre Zugangsdaten sind korrekt aber es existieren keine Zugangsberechtigungen.',
	},
	{
		error: 'no persons',
		header: 'Keine Berechtigung',
		message:
			'Ihre Zugangsdaten sind korrekt aber es existiert keine Person zu ihrem Benutzerkonto.',
	},
	{
		// Gesetzt von app/Http/Middleware/ActiveTeamMember.php (AAR-300/AAR-1677),
		// sobald ein Teammitglied `active = false` hat und im Mandanten keinen
		// `persons`-Datensatz besitzt.
		//
		// Roher Text, KEIN i18n-Schluessel: ShowError.vue rendert `header` und
		// `message` direkt (`:title=`, `v-html=`) ohne Uebersetzung. Ein Schluessel
		// wuerde dem Nutzer woertlich angezeigt. Die zweisprachige Fassung fuer die
		// Fehlerseite liegt in plugins/i18n/errorMessages.{de,en}.ts.
		error: 'team member deactivated',
		header: 'Zugang deaktiviert',
		message:
			'Ihr Zugang wurde deaktiviert. Bitte wenden Sie sich an Ihre Hausverwaltung.',
	},
	{
		// Gesetzt von TeamController::update() (AAR-300/AAR-1675), wenn ein Teammitglied
		// die EIGENE Zeile deaktivieren will. Ueber die Oberflaeche ist der Knopf dort
		// ausgeblendet — erreichbar bleibt der Fall aus einem alten Tab oder per API.
		//
		// Roher Text, KEIN i18n-Schluessel: gleiche Begruendung wie beim Eintrag darueber.
		error: 'cannot deactivate self',
		header: 'Nicht möglich',
		message:
			'Sie können Ihren eigenen Zugang nicht deaktivieren. Bitte lassen Sie das von einem anderen Teammitglied oder Ihrer Verwaltung erledigen.',
	},
	{
		// Gesetzt von TeamController::update() (AAR-300/AAR-1675): ohne `can_settings`
		// darf die eigene Zeile gepflegt, aber nicht hochgestuft werden.
		error: 'cannot change own permissions',
		header: 'Nicht möglich',
		message:
			'Sie können Ihre eigenen Berechtigungen nicht ändern. Bitte wenden Sie sich an Ihre Verwaltung.',
	},
	{
		error: 'retry-after',
		header: '',
		message:
			'Zu viele fehlerhafte Versuche. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
	},
	{
		error: 'The selected email is invalid.',
		header: '',
		message: 'Es existiert kein Account zur angegebenen E-Mail Adresse.',
	},
	{
		error: 'The new password confirmation does not match.',
		header: '',
		message:
			'Das eingegebene neue Passwort stimmt nicht mit der Bestätigung überein.',
	},
	{
		error: 'model_not_found',
		header: '',
		message: 'Die angeforderte Information konnte nicht geladen werden.',
	},
]
